import React from 'react';
import styled from 'styled-components';
import DeviceType from 'features/POSRegisters/interfaces/DeviceType';
import Icon from '@mdi/react';
import {
  mdiCloudCog,
  mdiServerNetwork,
  mdiWan,
  mdiCashRegister,
  mdiTablet,
  mdiCreditCardOutline,
  mdiPrinterPos,
} from '@mdi/js';

const StyledIcon = styled(Icon)`
  color: ${props => props.theme.text};
  flex-shrink: 0;
`;

function getIcon(deviceType: DeviceType, className?: string) {
  switch (deviceType) {
    case DeviceType.CLOUD_SERVICES:
      return <StyledIcon path={mdiCloudCog} size={1} className={className} />;
    case DeviceType.NETWORK_CIRCUIT:
      return <StyledIcon path={mdiWan} size={1} className={className} />;
    case DeviceType.NETWORK_SWITCH:
      return <StyledIcon path={mdiServerNetwork} size={1} className={className} />;
    case DeviceType.REGISTER:
      return <StyledIcon path={mdiCashRegister} size={1} className={className} />;
    case DeviceType.IPAD:
      return <StyledIcon path={mdiTablet} size={1} className={className} />;
    case DeviceType.IPAD_MINI:
      return <StyledIcon path={mdiTablet} size={0.7} className={className} />;
    case DeviceType.RECEIPT_PRINTER:
      return <StyledIcon path={mdiPrinterPos} size={1} className={className} />;
    case DeviceType.PAYMENT_TERMINAL:
      return <StyledIcon path={mdiCreditCardOutline} size={1} className={className} />;
    default:
      return <StyledIcon path={mdiCashRegister} size={1} className={className} />;
  }
}

interface DeviceIconsProps {
  deviceType: DeviceType;
  className?: string;
}

export default function DeviceIcons({deviceType, className}: DeviceIconsProps) {
  return getIcon(deviceType, className);
}
